import { getRouteApi } from '@tanstack/react-router';

export const jobsRouteApi = getRouteApi('/_index/jobs');
